export default __webpack_public_path__ + "static/media/577add19-bd28-4cf0-b0f5-e883f3eb611a.2c4ffbac.jpg";